const createRangeArray = (min: number, max: number) => {
	if (max < min) {
		throw new Error("max should be greater than or equal to min");
	}

	const array: number[] = [];
	for (let i = min; i <= max; i++) {
		array.push(i);
	}
	return array;
};

export default createRangeArray;
